import React, { useState } from "react";
import "../styles/Services.css";

// Import images
import image1 from "../assets/preis_bilder/Fruehuebtsich.png";
import image2 from "../assets/preis_bilder/FrischFesch.png";
import image3 from "../assets/preis_bilder/FlottesLottchen2.png";
import image4 from "../assets/preis_bilder/EinmalKurz.png";
import image5 from "../assets/preis_bilder/TerrierCo.png";
import image6 from "../assets/preis_bilder/WunschlosGlück.png";

const servicesData = [
    {
        id: 1,
        title: " Früh übt sich",
        shortDescription: "Eingewöhnung und Kennenlernen (nicht nur für Welpen) ",
        fullDescription: `
                <p>Der erste Besuch im Hundesalon kann für viele Hunde aufregend oder sogar beängstigend sein - besonders für junge, sensible oder unerfahrene Tiere. Deshalb biete ich eine behutsame Eingewöhnung an, bei dem Ihr Hund in Ruhe den Salon, die Geräusche und die Abläufe kennenlernen darf.</p>
                    <ul style='text-align: left;'>
                        <li>Haut- und Haaranalyse
                        <br>Individuelle Beurteilung von Haut- und Fellzustand</li>
                        <li>Individuelle Beratung - auch für die Pflege und das Üben zuhause</li>
                        <li>Rücksichtsvolles, gefühlvolles Heranführen an Geräusche, Geräte und Berührungen</li>
                        <li>Kein Zwang, kein Stress - wir gehen im Tempo Ihres Hundes</li>
                    </ul>
                <p><strong>Preis:</strong> nach Zeitaufwand 
                <br>68,- € pro Stunde</p>
`,
         image: image1, // Use imported image
    },
    {
id: 2,
        title: " Frisch und Fesch",
        shortDescription: "Standardpflege - Für das Wohlbefinden Ihres Hundes",
        fullDescription: `
                <p>Unsere Standardpflege umfasst eine rundum abgestimmte Behandlung - ganz nach den Bedürfnissen Ihres Lieblings und den rassespezifischen Anforderungen.</p>
                <ul style='text-align: left;'>
                        <li>Haut- und Haaranalyse
                        <br>Individuelle Beurteilung von Haut- und Fellzustand</li>
                        <li>Waschen mit Shampoo und Conditioner
                        <br>Sanfte Reinigung mit hochwertigen, auf Haut und Felltyp abgestimmtem Shampoo und Conditioner.</li>
                        <li>Föhnen oder Blowern
                        <br>Gründliches Trocknen mit professionellen Geräten - schonend und effektiv.</li>
                        <li>Bürsten und Unterwollentfernung
                        <br>Sorgfältiges Ausbürsten des Fells inklusive Entfernung der Unterwolle.</li>
                        <li>Schneiden oder Scheren
                        <br>Nach Ihrem Wunsch oder nach dem offiziellen Rassestandard (FCI).</li>
                        <li>Pfoten ausscheren
                        <br>Sauberes Ausscheren der Pfoten zur Pflege und Vorbeugung von Verfilzungen.</li>
                </ul>    
                <p><strong>Preis (ab):</strong>
                    <ul style='text-align: left;'>
                        <li>Minnie (bis 29 cm): ab 70,- €</li>
                        <li>Boomer( 30-39 cm): ab 90,- €</li>
                        <li>Milo (40-49 cm): ab 115,- €</li>
                        <li>Mabel (50-59 cm): ab 135,- €</li>
                        <li>Beethoven (> 60 cm): ab 155,- €</li>
                    </ul>
                </p>`,
        image: image2, // Use imported image
    },
    {
id: 3,
        title: " Flottes Lottchen",
        shortDescription: " Schnell wieder sauber!",
        fullDescription: `
                <p>Perfekt für eine Auffrischung zwischen den großen Pflege-Terminen!</p>
                <ul style='text-align: left;'>
                    <li>Haut- und Haaranalyse
                    <br>Individuelle Bestimmung von Felltyp und Hautbeschaffenheit für die bestmögliche Pflege. </li>
                    <li>Waschen mit abgestimmtem Shampoo und Conditioner
                    <br>Sanfte Reinigung mit hochwertigen Produkten - passend zu Haut und Fell Ihres Lieblings. </li>
                    <li>Blowern oder Föhnen
                    <br>Gründliches Trocknen mit viel Ruhe und Geduld - für ein rundum gepflegtes Fell. </li>
                </ul>
                <p><strong>Preis (ab):</strong>
                    <ul style='text-align: left;'>
                        <li>Minnie (bis 29 cm): ab 45,- €</li>
                        <li>Boomer( 30-39 cm): ab 55,- €</li>
                        <li>Milo (40-49 cm): ab 69,- €</li>
                        <li>Mabel (50-59 cm): ab 89,- €</li>
                        <li>Beethoven (> 60 cm): ab 115,- €</li>
                    </ul>
                </p>
`,
        image: image3, // Use imported image
    },
    {
        id: 4,
        title: " Einmal kurz bitte . . .",
        shortDescription: "Pflege ohne Waschen",
        fullDescription: `
                <ul style='text-align: left;'>
                    <li><strong>Schneller Schnitt ohne Waschen</li></strong>
                    <p>Ein schneller Schnitt ohne vorheriges Waschen ist nur in Ausnahmefällen möglich. Ideal für gepflegte Hunde und unverfilztem Fell.</p>
                    -Bei zu Hause frisch gebadeten Hunden (max. 24 Std.) und regelmäßig gepflegtem Fell
                    <br> -Wenn eine schnelle Auffrischung gewünscht wird</p>
                    <li><strong>Bürsten und Carden ohne Waschen</li></strong>
                    <p>Für Hunde mit dichter Unterwolle bieten wir eine schonende Alternative zum Waschen an: gründliches Bürsten und Carden.
                    <br>Diese Methoden entfernen lose Haare und lösen die Unterwolle, ohne das Fell zu strapazieren. So können wir das Fell entwirren und frisch aussehen lassen, ohne es zu waschen - perfekt für eine schnelle Pflege zwischendurch.</p>
                </ul>
                <p><strong>Preis (ab):</strong>
                    <ul style='text-align: left;'>
                        <li>Minnie (bis 29 cm): ab 55,- €</li>
                        <li>Boomer( 30-39 cm): ab 65,- €</li>
                        <li>Milo (40-49 cm): ab 69,- €</li>
                        <li>Mabel (50-59 cm): ab 89,- €</li>
                        <li>Beethoven (> 60 cm): ab 115,- €</li>
                    </ul>
                </p>
`,
        image: image4, // Use imported image
    },
    {
        id: 5,
        title: " Terrier-Dackel-Spaniel und Co.",
        shortDescription: "Handstripping (Trimmen von Hand)",
        fullDescription: `
                <p>Für bestimmte Hunderassen wie Terrier, Rauhaardackel, Spaniels und andere mit drahtigem oder festem Fell ist das Trimmen von Hand (Handstripping) die empfohlene Methode der Fellpflege. Dabei werden lose, abgestorbene Haare schonend per Hand entfernt, anstatt geschnitten. So bleibt die natürliche Fellstruktur erhalten, und Haut sowie Haar bleiben gesund.
                </p>
                <p><strong>Dauer und Preise:</strong> 
                <br>nach Aufwand
                <br>70 - 75 € pro Stunde</p>
                <p><strong>Bitte beachten Sie:</strong>
                <br>Die Dauer des Termins hängt vom Fellzustand und der Kooperation Ihres Hundes ab. Für ein optimales Ergebnis sollte das Handstripping regelmäßig erfolgen - idealerweise alle 8–12 Wochen. </p>
`,
        image: image5, // Use imported image
    },
    {
id: 6,
        title: "Wunschlos Glücklich",
        shortDescription: " Ihr persönliches Pflege- und Wohlfühlpaket für Ihren Vierbeiner",
        fullDescription: `     
                <p>Stellen Sie ganz einfach Ihr individuelles Pflegepaket für Ihren Liebling zusammen - von sanfter Fellpflege bis zu verwöhnenden Extras. Alles, was Ihr Vierbeiner braucht, für mehr Wohlbefinden und Entspannung.
                Gönnen Sie Ihrem Hund das Rundum-sorglos-Paket - liebevoll, maßgeschneidert und genau auf seine Bedürfnisse abgestimmt. Denn so werden Sie und Ihr Vierbeiner wirklich wunschlos glücklich!</p>
                <ul style='text-align: left;'>
                    <li>Nagayu SPA (nur in Verbindung mit Flottem Lottchen oder Frisch und Fesch) ab 10,00 €</li>
                    <li>Thalasso-Anwendung (nur in Verbindung mit Flottem Lottchen oder Frisch und Fesch) ab 12,00 €</li>
                    <li>Pet Esthè Spa Mud Shampoo (nur in Verbindung mit Flottem Lottchen oder Frisch und Fesch) ab 3,50 €</li>
                    <li>Augenpflege inkl. Augen freischneiden (auch als Einzelleistung buchbar) ab 15,00 €</li>
                    <li>Pfotenausscheren und in Form schneiden (auch als Einzelleistung buchbar) ab 15,00 €</li>
                    <li>Ballen- und Krallenpflege (auch als Einzelleistung buchbar) ab 9,00 €</li>
                    <li>Ohrenpflege (auch als Einzelleistung buchbar) ab 9,00 €</li>
                    <li>Nasenpflege (auch als Einzelleistung buchbar) ab 3,00 €</li>
                    <li>Hundeparfum 1,80 €</li>
                </ul>
`,
        image: image6, // Use imported image
    },



        
];

const Services = () => {
    const [expandedCard, setExpandedCard] = useState(null);

    const toggleCard = (id) => {
        setExpandedCard(expandedCard === id ? null : id);
    };

    return (
        <section className="services">
            <h2>Meine Leistungen</h2>
            <p>Die Preise richten sich immer nach Pflegezustand, Größe, Verhalten des Hundes und nach Aufwand und dienen lediglich als Anhaltspunkt.</p>
            <div className="services-grid">
                {servicesData.map((service) => {
                    const isExpanded = expandedCard === service.id;

                    return (
                        <div
                            key={service.id}
                            className={`service-card ${isExpanded ? "expanded" : ""}`}
                            aria-expanded={isExpanded}
                            onClick={() => toggleCard(service.id)}
                        >
                            {/* Render the image */}
                            <img
                                src={service.image}
                                alt={service.title}
                                className="service-image"
                            />
                            <h3>{service.title}</h3>
                            <p
                                dangerouslySetInnerHTML={{
                                    __html: isExpanded
                                        ? service.fullDescription
                                        : service.shortDescription,
                                }}
                            />
                            <button
                                className="toggle-button"
                                onClick={(e) => {
                                    e.stopPropagation(); // Prevent triggering parent div click
                                    toggleCard(service.id);
                                }}
                                aria-controls={`service-${service.id}`}
                            >
                                {isExpanded ? "Zeige weniger" : "Mehr Infos"}
                            </button>
                        </div>
                    );
                })}
            </div>
           
            
           </section>
    );
};

export default Services;